<span class="description">
  {{ nameKey | translate }}
</span>
<glxy-alert type="tip" *ngIf="alertKey">
  {{ alertKey | translate }}
</glxy-alert>
